export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/(admin)/coupons": [4,[2]],
		"/(admin)/dashboard": [5,[2]],
		"/(admin)/delivery": [6,[2]],
		"/(admin)/delivery/drivers": [7,[2]],
		"/(admin)/devices": [8,[2]],
		"/(admin)/faqs": [9,[2]],
		"/(admin)/franchises": [10,[2]],
		"/(admin)/inquiries": [11,[2]],
		"/(admin)/inquiries/categories": [12,[2]],
		"/(admin)/inquiries/templates": [13,[2]],
		"/login": [33],
		"/(admin)/monitoring": [14,[2]],
		"/(admin)/notices": [15,[2]],
		"/(admin)/notices/[id]": [16,[2]],
		"/(admin)/notifications": [19,[2]],
		"/(admin)/notification/settings": [17,[2]],
		"/(admin)/notification/sms": [18,[2]],
		"/(admin)/oilmanager": [20,[2]],
		"/(admin)/oilmanager/mapping/stores": [21,[2]],
		"/(admin)/oilmanager/mapping/users": [22,[2]],
		"/(admin)/oilmanager/price-schedule": [23,[2]],
		"/(admin)/oilmanager/sync-history": [24,[2]],
		"/(admin)/orders": [25,[2]],
		"/(admin)/payments": [26,[2]],
		"/(admin)/products": [27,[2]],
		"/(admin)/promotions": [28,[2]],
		"/(admin)/stats": [29,[2]],
		"/(admin)/stores": [30,[2]],
		"/(admin)/users": [31,[2]],
		"/(admin)/waste-oil": [32,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';